import { render, staticRenderFns } from "./SearchResultsHeader.vue?vue&type=template&id=de467130&scoped=true&"
import script from "./SearchResultsHeader.vue?vue&type=script&lang=js&"
export * from "./SearchResultsHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsHeader.vue?vue&type=style&index=0&id=de467130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de467130",
  null
  
)

export default component.exports